export default __webpack_public_path__ + "static/media/Image-benefits.8a5249c4.png";